import * as React from "react";
import { classNames } from "src/common/classNames";

import * as styles from "./BlankLink.module.less";

export type PropsBlankLink = {
  href: string;
  children?: React.ReactNode | React.ReactNode[];
  title?: string;
  className?: string;
  download?: string;
  underline?: boolean;
  color?: "primary-orange" | "text-main";
  onMouseDown?: React.DOMAttributes<HTMLAnchorElement>["onMouseDown"];
};

export const BlankLink: React.FC<PropsBlankLink> = ({
  href,
  children,
  title,
  className,
  download,
  underline = false,
  color = "text-main",
  onMouseDown,
}) => (
  <a
    href={href}
    download={download}
    target="_blank"
    rel="noopener noreferrer"
    title={title}
    className={classNames([
      styles.link,
      className,
      [underline, styles.underline],
      color ? styles[color] : null,
    ])}
    onClick={(e) => e.stopPropagation()}
    onMouseDown={(e) => {
      // Это магическое действие необходимо, чтобы срабатывал клик на ссылку. Иначе событие клика не происходит.
      e.stopPropagation();
      e.preventDefault();
      onMouseDown?.(e);
    }}
  >
    {children}
  </a>
);
